export default {"src":"/_next/static/media/fair.fb71c2eb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};